/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Such_Novel_Cougar_FlopInputs */

const fr_such_novel_cougar_flop = /** @type {(inputs: Such_Novel_Cougar_FlopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payé`)
};

/**

* @param {Such_Novel_Cougar_FlopInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const such_novel_cougar_flop = /** @type {((inputs?: Such_Novel_Cougar_FlopInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Such_Novel_Cougar_FlopInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_such_novel_cougar_flop(inputs)
});